const { debounce } = window.BAO.Utils

export class QAsToggle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.initialise()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 150)
    this.listeners.add(window, 'resize', this.debouncedResize)

    this.listeners.add(
      this.els.button.element,
      'click',
      this.handleButtonClick.bind(this),
    )
  }

  initialise () {
    this.removeAttribute('expanded')
    const isExpandable = this.contentHeight >= this.constrainingHeight

    this.toggleAttribute('expandable', isExpandable)

    this.setContentHeight()

    setTimeout(() => {
      this.toggleAttribute('initialised', true)
    }, 300)
  }

  onResize () {
    this.initialise()
  }

  handleButtonClick (event) {
    event.preventDefault()

    this.toggle()
  }

  toggle () {
    this.expanded = !this.expanded
  }

  setContentHeight () {
    const height = this.expanded ? `100%` : `${this.constrainingHeight}px`
    this.style.setProperty('--Content_Height', height)
  }

  get contentHeight () {
    return this.els?.content?.element?.offsetHeight
  }

  get constrainingHeight () {
    return this.els.image?.element?.querySelector('.rsp-Image').offsetHeight
  }

  get expanded () {
    return this.hasAttribute('expanded')
  }

  set expanded (expanded) {
    this.toggleAttribute('expanded', expanded)

    this.setContentHeight()

    this.els.button.element.setAttribute('aria-expanded', String(expanded))
  }
}

if (!customElements.get('qas-toggle')) {
  customElements.define('qas-toggle', QAsToggle)
}

export class QAsToggleMobile extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    if (!this.els.button?.exists) return

    this.listeners.add(
      this.els.button.element,
      'click',
      this.handleButtonClick.bind(this),
    )
  }

  handleButtonClick (event) {
    const buttonEl = event.target.closest(this.els.button.selector)
    const isExpanded = this.getAttribute('expanded') === 'true'
    this.setAttribute('expanded', !isExpanded)
    buttonEl.setAttribute('aria-expanded', !isExpanded)
  }
}

if (!customElements.get('qas-toggle-mobile')) {
  customElements.define('qas-toggle-mobile', QAsToggleMobile)
}
